<template>
	<div class="assocLeft">
		<div class="menuTitle">
			<p>{{navtitle}}</p>
		</div>
		<el-menu :default-active="defaultActive" :unique-opened="true" class="el-menu-vertical-demo" @open="handleOpen"
			@close="handleClose" active-text-color="#ffffff" text-color="#ffffff">

			<!-- 没有二级菜单 -->
			<el-menu-item v-if="issecond" v-for="(item,index) in navlist" :key="index" @click="showLeft(index)"
				:index="String(index)">{{item.label}}</el-menu-item>

			<!-- 有二级菜单 -->
			<el-submenu v-if="!issecond" v-for="(item,index) in navlist" :key="index" :index="String(index)">
				<template slot="title">
					<!-- <i class="el-icon-arrow-down"></i> -->
					<span slot="title">{{item.label}}</span>
				</template>
				<el-menu-item v-for="(key,index2) in item.children" :key="index2"
					:index="String(index)+'-'+String(index2)" @click="showLeft(index2)">{{key.label}}</el-menu-item>
			</el-submenu>

		</el-menu>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				defaultActive: '0'
			}
		},
		props: {
			navtitle: {
				type: String,
				default: "导航栏"
			},
			navlist: {
				type: Array,
				default: () => {
					return []
				}
			},
			// 判断有无二级菜单 true-无二级，false-有二级
			issecond: {
				type: Boolean,
				default: true
			}
		},
		created() {
			// 新增功能 处理url带内容参数传递
			const urlparam = decodeURI(this.getQueryParams('detail'))
			// 如果带了三级
			const newUrlParam = decodeURI(this.getQueryParams('title'))

			let timer = setInterval(() => {
				if (this.navlist.length) {
					clearInterval(timer)
					this.navlist.forEach((item, index, array) => {
						if (item.label === urlparam) {
							if (this.issecond) {
								// 无二级
								this.showLeft(index)
								this.defaultActive = String(index)
							} else {
								// 有二级
								const UrlParam = newUrlParam === 'false' ? false : newUrlParam
								if (UrlParam) {
									item.children.forEach((newItem, key) => {
										if (newItem.label === UrlParam) {
											let code = String(index) + '-' + key
											this.showLeft(code)
											// this.handleOpen(code)
											this.defaultActive = code
										}
									})
								} else {
									let code = String(index) + '-' + '0'
									this.showLeft(code)
									// this.handleOpen(code)
									this.defaultActive = code
								}
							}
						}
					})
					// 如果默认没检测到有变化，主动触发请求
					if (this.defaultActive === '0') {
						if (this.issecond) {
							this.showLeft(0)
						} else {
							this.showLeft('0-0')
							this.defaultActive = '0-0'
						}
					}
				}
			}, 80)


		},
		methods: {
			// 获取路由参数
			getQueryParams(variable) {
				let href = window.location.href
				let query = href.substring(href.indexOf("?") + 1)
				let vars = query.split("&")
				for (let i = 0; i < vars.length; i++) {
					let pair = vars[i].split("=")
					if (pair[0] === variable) {
						return pair[1]
					}
				}
				return (false)
			},
			handleOpen(e) {
				// console.log('open', e)
				this.$emit('openfresh', e)
			},
			handleClose(e) {
				// console.log('Close', e)
			},
			showLeft(e) {
				// console.log('e', e)
				this.$emit('navrefresh', e)
			}
		},
	}
</script>
<style>

</style>
